export async function loadConfig() {
    const defaults = {
        url: "https://rewrite.system.usedsoft.de/api/",
        //url: "https://usedsoft-laravel-live.test/api/",
        debug: false,
        staging: false,
    }

    try {
        const response = await fetch('/config.json', {
            cache: 'no-store'
        })

        if (!response.ok) {
            return defaults
        }

        const config = await response.json()

        return {
            ...defaults,
            ...config,
        }

    } catch (e) {
        return defaults
    }
}